import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common'
//modules
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';

//services
import { AuthenticationService, CompanyService, AppConfigService, DepartmentService, JobLevelService, 
    RatingService, LookupCacheService, PreviousRouteService, UserProfileService } from './services';
import { Globals } from './shared/globals';
//guards
import { AuthGuard } from './guards/auth.guard';
import { NotLoggedInGuard } from './guards/not-logged-in.guard';
import { ResetGuard } from './guards/reset.guard';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';
import { IsWebAdminGuard } from './guards/is-web-admin.guard';
//components 
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';

import { APP_INITIALIZER } from '@angular/core';
import { IAppConfig } from './models/app-config';

export function initializeApp(appConfig: AppConfigService, cacheService: LookupCacheService): Function {
    return () => appConfig.load().then((setting: IAppConfig) => {
        return cacheService.load(setting.apiServerURL);
    });
}

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        AppRoutingModule,
        SharedModule
    ],
    providers: [
        AuthenticationService,
        AuthGuard,
        NotLoggedInGuard,
        ResetGuard,
        CanDeactivateGuard,
        IsWebAdminGuard,
        AppConfigService,
        CompanyService,
        DepartmentService,
        JobLevelService,
        RatingService,
        PreviousRouteService,  
        UserProfileService,
        Globals,
        DatePipe,
        { provide: APP_INITIALIZER,
        useFactory: initializeApp,
        deps: [AppConfigService, LookupCacheService], multi: true }
    ],
    schemas:[
        CUSTOM_ELEMENTS_SCHEMA
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
